export default __webpack_public_path__ + "static/media/coach_guideme_softclix_lancingkit_lancets200_strips250_scale_cuff_white@1x.d9b7a287.webp";